import { createFileRoute, redirect } from '@tanstack/react-router'
import { isAdminUser } from '@/lib/role-guards'
import { ApprovedApplicationsPage } from '@/features/admin/applications'
import { ApplicationListSkeleton } from '@/features/admin/applications/components/ApplicationListSkeleton'
import { queryClient } from '@/lib/query'
import {
  getApprovedApplicationsWithDetails,
  getGetApprovedApplicationsWithDetailsQueryKey,
} from '@/utils/api/membership-service'

export const Route = createFileRoute('/_authenticated/admin/approved-applications')({
  beforeLoad: ({ context }) => {
    if (context.auth.isLoading) {
      return
    }
    if (!isAdminUser(context.auth.user)) {
      throw redirect({ to: '/dashboard' })
    }
  },
  component: ApprovedApplicationsPage,
  pendingComponent: ApplicationListSkeleton,
  loader: async () => {
    await queryClient.ensureQueryData({
      queryKey: getGetApprovedApplicationsWithDetailsQueryKey({ page: 0, size: 10 }),
      queryFn: () => getApprovedApplicationsWithDetails({ page: 0, size: 10 }),
    })
  },
})
